import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const UploadSession = z.object({
  uri: z.string()
});

const c = initContract();

export default c.router({
  // Used by: Admin
  createImageUploadSession: {
    method: 'GET',
    path: '/storageuri',
    responses: {
      200: UploadSession
    },
    summary: 'Create an image upload session'
  },
  createUploadSession: {
    method: 'GET',
    path: '/storageuri',
    query: z.object({
      path: z.string()
    }),
    responses: {
      200: UploadSession
    },
    summary: 'Create an image upload session'
  },
  downloadStorageItem: {
    method: 'GET',
    path: '/storagebloburi',
    query: z.object({
      path: z.string()
    }),
    responses: {
      200: z.object({
        uri: z.string()
      })
    },
    summary: 'Download a storage item'
  }
});
